// extracted by mini-css-extract-plugin
module.exports = {"hotelFacility":"HotelFacility_hotelFacility__2UiTJ","facilityTooltip":"HotelFacility_facilityTooltip__2OggR"};